import React from 'react'
import CommonContact from '../CommonComponent/CommonContact'

export default function Contact() {
  return (
    <>
      <CommonContact/>
    </>
  )
}
